import {
  SALES_BANNER,
  SALES_BANNER_STEPS,
  BLOG_LANGUAGES,
  STATIC_LINKS,
  MEMBERS_AREA_POST_ID,
  HOTMART_BLOG_API
} from './constants';

const getBlogUrl = (shortLocale) => {
  const blogLanguage = BLOG_LANGUAGES[shortLocale] || BLOG_LANGUAGES.en;

  return `${STATIC_LINKS.HOTMART_BLOG}${blogLanguage}`;
};

const getBannerSteps = () => Object.keys(SALES_BANNER_STEPS);

const isMakeSalesStep = (index) => index === SALES_BANNER_STEPS.MAKE_SALES;

const isFirstSaleStep = (index) =>
  index === SALES_BANNER_STEPS.MAKE_YOUR_FIRST_SALE;

const isYouSoldStep = (index) =>
  index === SALES_BANNER_STEPS.CONGRATULATION_YOU_SOLD;

const isNumberSalesStep = (index) =>
  index === SALES_BANNER_STEPS.CONGRATULATION_YOU_NUMBER_SALES;

const getStepIndex = (step) => {
  return getBannerSteps().indexOf(step) === -1
    ? SALES_BANNER_STEPS.MAKE_SALES
    : step;
};

const getSalesBannerProps = (index) => SALES_BANNER[index];

const getClubSalesPost = (shortLocale) =>
  STATIC_LINKS.HOTMART_BLOG_CLUB_SALES[shortLocale] ||
  STATIC_LINKS.HOTMART_BLOG_CLUB_SALES.en;

const getMembersAreaPostUrl = (shortLocale) => {
  const postId = MEMBERS_AREA_POST_ID[shortLocale] || MEMBERS_AREA_POST_ID.en;

  return `${HOTMART_BLOG_API}posts/${postId}`;
};

const getHelperCenterUrl = (shortLocale) =>
  STATIC_LINKS.HOTMART_FAQ[shortLocale] ||
  STATIC_LINKS.HOTMART_FAQ[BLOG_LANGUAGES.en];

export {
  getBannerSteps,
  isMakeSalesStep,
  isFirstSaleStep,
  isYouSoldStep,
  isNumberSalesStep,
  getStepIndex,
  getSalesBannerProps,
  getBlogUrl,
  getClubSalesPost,
  getMembersAreaPostUrl,
  getHelperCenterUrl
};
